const messages = [
  {
    path: 'messages',
    name: 'messages',
    icon: 'cil-short-text',
    meta: {
      requiredRole: ['admin', 'middleAdmin'],
    },
    children: [
      {
        path: '',
        showInMenu: true,
        name: 'messages_list',
        components: {
          content: () => import('@/views/pages/messages/List.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
        }
      },
      {
        path: 'new',
        showInMenu: true,
        name: 'messages_new',
        components: {
          content: () => import('@/views/pages/messages/New.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
        }
      },
      {
        path: ':id',
        name: 'messages_edit',
        components: {
          content: () => import('@/views/pages/messages/Edit.vue')
        },
        meta: {
          requiredRole: ['admin', 'middleAdmin'],
        }
      }
    ]
  },
  {
    path: 'threads',
    name: 'threads',
    icon: 'cil-chat-bubble',
    showInMenu: true,
    components: {
      content: () => import('@/views/pages/threads/Index.vue')
    },
    meta: {
      requiredRole: ['admin'],
      moduleSlug: 'threads'
    }
  }
]

export default messages
